var map = {
	"./pvbj/1.jpg": 665,
	"./pvbj/2.jpg": 9902,
	"./pvbj/3.jpg": 7947,
	"./pvbj/4.jpg": 8152,
	"./pvbj/5.jpg": 6021,
	"./pvbj/6.jpg": 6122,
	"./pvbj/7.jpg": 1959,
	"./pvbj/8.jpg": 2900,
	"./pvbj/9.jpg": 7233,
	"./sv/1.jpg": 2480,
	"./sv/2.jpg": 6207,
	"./sv/3.jpg": 8146,
	"./sv/4.jpg": 3377,
	"./sv/5.jpg": 1572,
	"./sv/6.jpg": 7635,
	"./sv/7.jpg": 7526,
	"./sv/8.jpg": 4341,
	"./sv/9.jpg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2745;